import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';
import { ParticleBehaviourTagType } from 'app/enum/Particles';
import { ParticleBehaviour } from '../ParticleBehaviour';
import { HomeParticle } from 'app/views/home/webgl/particles/fields/HomeParticle';

export class ParticlePosition extends ParticleBehaviour implements particles.ParticlePosition {
	public xOffset: number = 0;
	protected _tags: Array<ParticleBehaviourTagType> = [ParticleBehaviourTagType.POSITION];
	private _targetPosition: geometry.Vector2 = { x: 0, y: 0 };

	//GETTER / SETTER
	//-------------------------------------------------------------------------------------
	public set targetPosition(v: geometry.Vector2) {
		this._targetPosition = v;
	}

	public set targetX(x: number) {
		this._targetPosition.x = x;
	}

	public set targetY(y: number) {
		this._targetPosition.y = y;
	}

	public get targetX(): number {
		return this._targetPosition.x;
	}

	public get targetY(): number {
		return this._targetPosition.y;
	}

	public set followParticle(p: HomeParticle | null) {
	}

	//PUBLIC
	//-------------------------------------------------------------------------------------
	public set(v: geometry.Vector2) {
		this._targetPosition = v;
	}

	public tick(): void {
		//Set the base level target others such as repell/parallax will just +/= this amount)
		//The settings on the ParticlePostionScaleAlphaRotation will effect the motion to the target this point
		this._animatedProps.targetX = this._targetPosition.x;
		this._animatedProps.targetY = this._targetPosition.y;
	}
}
